import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { AuthenticationService } from './authentication.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthenticationInfo } from '../models/authentication-info.model';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UserService {
  private _user: BehaviorSubject<User>;
  public get user(): Observable<User> {
    return this._user.skipWhile(user => user === undefined);
  }

  private _token: BehaviorSubject<string>;
  public get token(): Observable<string> {
    return this._token.skipWhile(token => token === undefined);
  }

  constructor(
    private authenticationService: AuthenticationService,
  ) {
    this._user = new BehaviorSubject<User>(undefined);
    this._token = new BehaviorSubject<string>(undefined);
    this.authenticationService.authenticationInfo.subscribe((authenticationInfo: AuthenticationInfo) => {
      this._user.next(authenticationInfo.user);
      this._token.next(authenticationInfo.token);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/auth/user.service.ts